import KBBDealerRatings from './KBBDealerRatings';

export default KBBDealerRatings;
